import Dexie from 'dexie';

import { SYNC_SCHEMA } from './schema';

// Um store Dexie por tabela de dados, mais as 3 tabelas de controle da fila.
// Índices: `uuid` é a chave primária (estável mesmo antes de sincronizar; o
// `id` do servidor só existe depois do primeiro push bem-sucedido). Os
// campos de FK declarados em `fkUuid` também viram índice, pois guardam o
// uuid do registro pai (não o id) — ver comentário em schema.js.
function construirStores() {
  const stores = {};

  for (const { tabela, fkUuid } of Object.values(SYNC_SCHEMA)) {
    const indices = ['uuid', 'id', 'atualizado_em', 'excluido_em', ...fkUuid.map((fk) => fk.campo)];
    stores[tabela] = indices.join(', ');
  }

  stores.sync_queue = '++queue_id, tabela, record_uuid, status, criado_em';
  stores.uuid_map = 'uuid, tabela, status';
  stores.meta = 'chave';

  return stores;
}

export const db = new Dexie('agrosoft_offline');
db.version(1).stores(construirStores());
// Versão 2: adiciona tipo_falha como índice para requeue seletivo por categoria
// ('permissao' | 'validacao' | 'rede'). Entradas anteriores ficam sem o campo
// e não aparecem nas queries por tipo_falha — comportamento correto.
db.version(2).stores({
  sync_queue: '++queue_id, tabela, record_uuid, status, criado_em, tipo_falha',
});
// Versão 3: adiciona tabelas para sessão de pesagem no brete (Card 11).
db.version(3).stores({
  sessao_pesagem: 'uuid, id, atualizado_em, excluido_em',
  linha_sessao_pesagem: 'uuid, id, atualizado_em, excluido_em, sessao',
});
// Versão 4: adiciona tabelas para Tipos de Máquinas e Fabricantes de Máquinas
// (com seus índices de FK `tipo_maquina` e `tipos_maquina`, declarados em
// schema.js → fkUuid).
db.version(4).stores({
  tipo_maquina: 'uuid, id, atualizado_em, excluido_em',
  fabricante_maquina: 'uuid, id, atualizado_em, excluido_em, tipos_maquina',
});
// Versão 5: adiciona tabela para Análise de Solo.
db.version(5).stores({
  analise_solo: 'uuid, id, atualizado_em, excluido_em, talhao',
});

export async function ultimaSincronizacao(tabela) {
  const registro = await db.meta.get(`ultima_sync:${tabela}`);
  return registro?.valor ?? null;
}

export async function marcarSincronizado(tabela, servidorEm) {
  await db.meta.put({ chave: `ultima_sync:${tabela}`, valor: servidorEm });
}
